import type * as React from "react";

import { cn } from "../../utils";
import { inputVariants } from "./input-variants";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        inputVariants(),
        // disabled state
        "disabled:bg-gray-100 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        // placeholder
        "placeholder:text-gray-500 placeholder:font-normal",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
